import React, { useEffect, useState } from "react";
import "../../index.css";
import "../../App.css";
import {
  Row,
  Col,
  Input,
  Typography,
  Radio,
  Select,
  Button,
  Space,
  Form,
  DatePicker,
  Spin,
} from "antd";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  handleUpdateDemoGraphic,
  handleGoToNextStep,
  handleUpdateDemoGraphicsAllergies,
  handleGoBack,
  saveStep0Api,
  handleUpdateErrorsOfOrderCreamForm,
} from "../../redux-toolkit/slices/orderCreamSlice";
import dayjs, { Dayjs } from "dayjs";
const { Option } = Select;

const OcDemographics = () => {
  const orderCreamForm = useSelector((state: RootState) => state.orderCream);
  const {
    demoGraphics,
    shippingDetails,
    selectedState,
    transactionId,
    isLoading,
  } = orderCreamForm;
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [dob, setDob] = useState<Dayjs | null>(null); // Set default date to January 1, 2006
  // const [dob, setDob] = useState("");
  const [weight, setWeight] = useState("");
  const [heightFeet, setHeightFeet] = useState("");
  const [heightInches, setHeightInches] = useState("");
  const [gender, setGender] = useState("");
  const [preg, setPreg] = useState("");
  const [allergies, setAllergies] = useState("");
  const [allergyEntries, setAllergyEntries] = useState([
    { id: 1, type: "", severity: "" },
  ]);
  useEffect(() => {
    form.setFieldsValue({
      dob: demoGraphics.dob ? dayjs(demoGraphics.dob) : null,
      weight: demoGraphics.weight,
      ft: demoGraphics.heightFeet,
      in: demoGraphics.heightInches,
      gender: demoGraphics.gender,
      pregnant: demoGraphics.pregnant,
      allergy: demoGraphics.allergy,
      allAllergies: demoGraphics.allAllergies,
    });
    setDob(dayjs(demoGraphics.dob));
    setWeight(demoGraphics.weight);
    setHeightFeet(demoGraphics.heightFeet);
    setHeightInches(demoGraphics.heightInches);
    setGender(demoGraphics.gender);
    setPreg(demoGraphics.pregnant);
    setAllergies(demoGraphics.allergy);
    setAllergyEntries(demoGraphics.allAllergies);
    console.log("demoGraphics", demoGraphics.allAllergies);
  }, []);
  // useEffect(() => {
  //   console.log("allergyEntries changed: ", allergyEntries);
  // }, [allergyEntries]);
  const handleWeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setWeight(e.target.value);
    dispatch(handleUpdateDemoGraphic({ key: "weight", value: e.target.value }));
  };

  const handleHeightFeetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setHeightFeet(e.target.value);
    dispatch(
      handleUpdateDemoGraphic({ key: "heightFeet", value: e.target.value })
    );
  };

  const handleHeightInchesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setHeightInches(e.target.value);
    dispatch(
      handleUpdateDemoGraphic({ key: "heightInches", value: e.target.value })
    );
  };

  const handleGenderChange = (e: any) => {
    setGender(e.target.value);
    // form.setFieldsValue({ gender: e.target.checked });
    dispatch(handleUpdateDemoGraphic({ key: "gender", value: e.target.value }));
  };

  const handlePregChange = (e: any) => {
    setPreg(e.target.value);
    dispatch(
      handleUpdateDemoGraphic({ key: "pregnant", value: e.target.value })
    );
  };

  const handleAllergiesChange = (e: any) => {
    setAllergies(e.target.value);
    dispatch(
      handleUpdateDemoGraphic({ key: "allergy", value: e.target.value })
    );
  };

  const handleAllergyTypeChange = (id: number, value: string) => {
    setAllergyEntries((prev) =>
      prev.map((entry) => (entry.id === id ? { ...entry, type: value } : entry))
    );
  };

  const handleSeverityChange = (id: number, value: string) => {
    setAllergyEntries((prev) =>
      prev.map((entry) =>
        entry.id === id ? { ...entry, severity: value } : entry
      )
    );
  };
  useEffect(() => {
    dispatch(handleUpdateDemoGraphicsAllergies(allergyEntries));
  }, [allergyEntries]);

  const handleAddEntry = () => {
    const newId = allergyEntries.length + 1;
    setAllergyEntries([
      ...allergyEntries,
      { id: newId, type: "", severity: "" },
    ]);
  };

  const handleRemoveEntry = (id: number) => {
    setAllergyEntries(allergyEntries.filter((entry) => entry.id !== id));
  };
  const handleDobChange = (date: Dayjs | null) => {
    setDob(date);
    if (date) {
      dispatch(
        handleUpdateDemoGraphic({
          key: "dob",
          value: date.format("MM/DD/YYYY"),
        })
      );
    }
  };
  const onFinish = async (values: any) => {
    console.log("onFinish called", values);
    
    // Additional validation for radio buttons (in case Form.Item validation is bypassed)
    const validGender = ["male", "female"];
    const validYesNo = ["yes", "no"];

    if (!gender || 
        gender === "" || 
        gender === null || 
        gender === undefined ||
        (typeof gender === 'string' && gender.trim() === "") ||
        !validGender.includes(gender)) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Please choose your gender."],
        })
      );
    }
    
    if (gender === "female" && 
        (!preg || 
         preg === "" || 
         preg === null || 
         preg === undefined ||
         (typeof preg === 'string' && preg.trim() === "") ||
         !validYesNo.includes(preg))) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Please choose if you're pregnant or not."],
        })
      );
    }
    
    if (!allergies || 
        allergies === "" || 
        allergies === null || 
        allergies === undefined ||
        (typeof allergies === 'string' && allergies.trim() === "") ||
        !validYesNo.includes(allergies)) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Please choose if you have allergies or not."],
        })
      );
    }
    
    if (!transactionId) {
      dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Transaction ID is missing. Please refresh the page."],
        })
      );
      return;
    }

    try {
      // Sanitize data to remove _id fields
      const sanitizedDemoGraphics = demoGraphics ? { ...demoGraphics } : {};
      delete (sanitizedDemoGraphics as any)._id;

      const sanitizedShippingDetails = shippingDetails
        ? { ...shippingDetails }
        : {};
      delete (sanitizedShippingDetails as any)._id;
      if ((sanitizedShippingDetails as any).address) {
        delete (sanitizedShippingDetails as any).address._id;
      }

      console.log("Calling saveStep0Api with:", {
        transactionId,
        demoGraphics: sanitizedDemoGraphics,
        shippingDetails: sanitizedShippingDetails,
        selectedState,
      });

      await dispatch(
        saveStep0Api({
          transactionId,
          demoGraphics: sanitizedDemoGraphics,
          shippingDetails: sanitizedShippingDetails,
          selectedState,
        })
      ).unwrap();

      console.log("Step 0 saved successfully");

      // Update URL with new step
      const newParams = new URLSearchParams(searchParams);
      newParams.set("step", "1");
      setSearchParams(newParams, { replace: true });

      dispatch(handleGoToNextStep());
    } catch (error) {
      console.error("Error saving step 0:", error);
      dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Failed to save step. Please try again."],
        })
      );
    }
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log("Form validation failed:", errorInfo);
    const errorMessages = errorInfo.errorFields?.map((field: any) => 
      field.errors?.[0] || "Please complete all required fields"
    ) || ["Please complete all required fields"];
    dispatch(
      handleUpdateErrorsOfOrderCreamForm({
        isError: true,
        errors: errorMessages,
      })
    );
  };
  return (
    <div className="demographics-entry">
      <Form
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        form={form}
        name="OrderCreamGetStarted"
        layout="vertical"
        className="w-full flex flex-col items-left"
      >
        <div className="flex flex-col gap-5 w-full">
          {/* Line 1: Date of Birth and Weight */}
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <div className="flex flex-col gap-2">
                <label className="h6 text-theme-text-secondary">
                  <strong>Date of Birth *</strong>
                </label>
                <Form.Item
                  name="dob"
                  rules={[{ required: true, message: "Please input your DOB" }]}
                >
                  <DatePicker
                    format="MM/DD/YYYY"
                    placeholder="Enter Date of Birth (MM/DD/YYYY)"
                    style={{ width: "100%" }}
                    value={dob}
                    onChange={handleDobChange}
                    className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="flex flex-col gap-2">
                <label className="h6 text-theme-text-secondary">
                  <strong>Weight (in lb.) *</strong>
                </label>
                <Form.Item
                  name="weight"
                  rules={[{ required: true, message: "Please input weight" }]}
                >
                  <Input
                    placeholder="Enter Weight"
                    value={weight}
                    onChange={handleWeightChange}
                    className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>

          {/* Line 2: Height */}
          <div className="flex flex-col gap-2">
            <label className="h6 text-theme-text-secondary">
              <strong>Height (in feet and inches) *</strong>
            </label>
            <Row gutter={[8, 8]}>
              <Col span={12}>
                <Form.Item
                  name="ft"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.reject(
                            new Error("Please input your height in feet")
                          );
                        }
                        if (value < 1 || value > 10) {
                          return Promise.reject(
                            new Error("Height (ft) must be between 1 and 10")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="ft."
                    value={heightFeet}
                    onChange={handleHeightFeetChange}
                    type="number"
                    className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="in"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.reject(
                            new Error("Please input your height in inches")
                          );
                        }
                        if (value < 1 || value > 11) {
                          return Promise.reject(
                            new Error("Height (in) must be between 1 and 11")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="in."
                    value={heightInches}
                    onChange={handleHeightInchesChange}
                    type="number"
                    className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>

          {/* Line 3: Gender */}
          <div className="flex flex-col gap-2">
            <label className="h6 text-theme-text-secondary">
              <strong>Gender *</strong>
            </label>
            <Form.Item
              name="gender"
              rules={[{ required: true, message: "Please choose your gender" }]}
            >
              <Radio.Group onChange={handleGenderChange} value={gender}>
                <Radio value="male">Male</Radio>
                <Radio value="female">Female</Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          {/* Pregnant section (conditional rendering based on gender) */}
          {gender === "female" && (
            <div className="flex flex-col gap-2">
              <label className="h6 text-theme-text-secondary">
                <strong>Are you currently pregnant? *</strong>
              </label>
              <Form.Item
                name="pregnant"
                rules={[
                  {
                    required: true,
                    message: "Please choose if you're pregnant/not",
                  },
                ]}
              >
                <Radio.Group onChange={handlePregChange} value={preg}>
                  <Radio value="yespreg">Yes</Radio>
                  <Radio value="nopreg">No</Radio>
                </Radio.Group>
              </Form.Item>
            </div>
          )}
          {/* Line 4: Allergies */}
          <div className="flex flex-col gap-2">
            <label className="h6 text-theme-text-secondary">
              <strong>
                Do you have any allergies or skin sensitivities? *
              </strong>
            </label>
            <Form.Item
              name="allergy"
              rules={[
                {
                  required: true,
                  message: "Please choose if you Have allergies",
                },
              ]}
            >
              <Radio.Group onChange={handleAllergiesChange} value={allergies}>
                <Radio value="no">No</Radio>
                <Radio value="yes">Yes</Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          {/* Allergy details section (conditional rendering based on allergies) */}
          {allergies === "yes" &&
            allergyEntries.map((entry, index) => (
              <div
                key={entry.id}
                className="flex flex-col gap-2"
                style={{ marginTop: "20px" }}
              >
                <label className="h6 text-theme-text-secondary">
                  {`Allergy Entry #${index + 1}`}
                </label>

                <Row gutter={16} align="middle">
                  <Col flex="auto">
                    {/* Removed name/rules so Form doesn’t override your controlled value */}
                    <Input
                      placeholder="Enter allergy type"
                      value={entry.type}
                      onChange={(e) =>
                        handleAllergyTypeChange(entry.id, e.target.value)
                      }
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
                    />
                  </Col>

                  <Col flex="auto">
                    <Select
                      placeholder="Select severity"
                      value={entry.severity}
                      onChange={(value) =>
                        handleSeverityChange(entry.id, value)
                      }
                      className="w-full"
                      style={{ height: "48px" }}
                      dropdownStyle={{ zIndex: 9999 }}
                    >
                      <Option value="mild">Mild</Option>
                      <Option value="moderate">Moderate</Option>
                      <Option value="severe">Severe</Option>
                      <Option value="life-threatening">Life-Threatening</Option>
                    </Select>
                  </Col>

                  <Col
                    flex="none"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "80px",
                    }}
                  >
                    <Button
                      shape="circle"
                      icon="+"
                      onClick={handleAddEntry}
                      style={{ marginRight: "10px" }}
                    />
                    {index > 0 && (
                      <Button
                        shape="circle"
                        icon="-"
                        onClick={() => handleRemoveEntry(entry.id)}
                      />
                    )}
                  </Col>
                </Row>
              </div>
            ))}

          {/* Submit Button */}
          <div
            className="flex justify-center gap-4"
            style={{ marginTop: "40px" }}
          >
            {/* <button
              onClick={() => dispatch(handleGoBack())}
              className="caption2 transition-colors duration-200"
              style={{ color: 'var(--primary-500)', textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Previous
            </button> */}
            <button
              type="submit"
              className="btn btn-primary btn-lg"
              disabled={isLoading}
              style={{ position: "relative", minWidth: "120px" }}
            >
              {isLoading ? (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <Spin size="small" />
                  Saving...
                </span>
              ) : (
                "Next"
              )}
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default OcDemographics;
